import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

function getAuthHeaders() {
  const token = sessionStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function buildQuery(params) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });
  const q = query.toString();
  return q ? `?${q}` : "";
}

export const detectionService = {
  async getEvents(params = {}) {
    const response = await fetch(
      `${GO_BACKEND_URL}/api/events${buildQuery(params)}`,
      { headers: { ...getAuthHeaders() } }
    );
    if (!response.ok) {
      throw new Error(`Unable to load detection events (${response.status})`);
    }
    return response.json();
  },

  async deleteAllEvents() {
    const response = await fetch(`${GO_BACKEND_URL}/api/events`, {
      method: "DELETE",
      headers: { ...getAuthHeaders() },
    });
    if (!response.ok) {
      throw new Error(`Unable to delete detection events (${response.status})`);
    }
    return response.json();
  },

  async getRecordingLink(streamID, timeISO) {
    const response = await fetch(
      `${GO_BACKEND_URL}/api/events/recording-link${buildQuery({ stream: streamID, time: timeISO })}`,
      { headers: { ...getAuthHeaders() } }
    );
    if (!response.ok) {
      throw new Error(`Unable to load recording link (${response.status})`);
    }
    return response.json();
  },
};

export default detectionService;
